interface RatingBadgeProps {
  rating: number;
  size?: "sm" | "md" | "lg";
}

export default function RatingBadge({ rating, size = "sm" }: RatingBadgeProps) {
  const sizeClass =
    size === "lg"
      ? "text-base px-3 py-1"
      : size === "md"
        ? "text-sm px-2.5 py-1"
        : "text-xs px-2 py-0.5";

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 font-label font-bold text-primary-950 ${sizeClass}`}
    >
      <i className="ri-star-fill text-[0.9em]" aria-hidden="true" />
      {rating.toFixed(1)}
    </span>
  );
}